import * as RestApi from 'core/network/RestApi';
import { OffsiteCampaign } from 'models/offsite/Campaign/OffsiteCampaign';

export interface GetBulkRetargetingCampaignsRequest {
  siteId: string;
}

export const getBulkRetargetingCampaignsQuery = async ({ siteId }: GetBulkRetargetingCampaignsRequest) => {
  const result = await RestApi.get<OffsiteCampaign[]>(`/sites/${siteId}/bulk_retargeting_campaigns`);
  return result.data;
};
